import { useTranslation } from 'react-i18next'

import { getQaSelector } from '../../../../../utils/common'
import Text from '../../../../Text'
import { CalendarItemStatus } from '../../../CalendarItemStatus'
import { QA_NAME_CALENDAR_TASK_MOVE_SUMMARY } from '../../CalendarTaskMoveModal.constants'

import { getCalendarTaskMoveStepLabel } from './TaskSummary.utils'

import * as styles from './TaskSummary.module.css'

function TaskSummary({ item }) {
  const { t } = useTranslation()

  return (
    <div
      {...getQaSelector({ value: QA_NAME_CALENDAR_TASK_MOVE_SUMMARY })}
      className={styles.TaskSummary}
    >
      <div className={styles.title}>
        <Text>{item.title}</Text>
        <CalendarItemStatus item={item} />
      </div>
      <Text isSecondary>{getCalendarTaskMoveStepLabel({ item, t })}</Text>
    </div>
  )
}

export default TaskSummary
